import { FormGroup, FormArray } from '@angular/forms';

export interface SntServerError {
  [k: string]: string | string[];
}

export interface SntServerErrorFilterFn {
  (errors: SntServerError): SntServerError;
}

export function excludeKeys(keys: string[]) {
  return (errors: SntServerError = {}) => {
    try {
      const filtered = Object.entries(errors).filter(([k]) => !keys.includes(k));

      return (<any>Object).fromEntries(filtered);
    } catch (e) {
      console.error(e);

      return {};
    }
  };
}

export function retrieveFormErrors(form: FormGroup, errors: SntServerError = {}) {
  let serverErrors: string[] = [];

  const fields = Object.keys(errors);

  for (const field of fields) {
    const error = errors[field];

    if (!form.controls[field]) {
      if (Array.isArray(error)) {
        serverErrors = serverErrors.concat(error);
      } else {
        serverErrors.push(error);
      }
    }
  }

  return serverErrors;
}

export function mapNestedErrors(
  form: FormGroup | FormArray,
  controlName: string,
  pathToControl: string[],
  errors: SntServerError,
) {
  const childError = errors[controlName];

  const childControl = form.get(pathToControl);

  if (childControl) {
    if (typeof childError === 'object') {
      if (Array.isArray(childError) && typeof childError[0] === 'string') {
        childControl.setErrors({ server: childError[0] });
        pathToControl.pop();
      } else {
        Object.keys(childError).forEach((control: string) => {
          if (typeof (childError as unknown as Record<string, string>)[control] === 'string') {
            childControl.setErrors({ server: (childError as unknown as Record<string, string>)[control] });
          }

          if (typeof (childError as unknown as Record<string, object>)[control] === 'object') {
            // Check if error object is not empty i.e. not {}
            // (empty error object means that there is no error for current control)
            // so if we've found an empty error object we will skip him
            if (Object.keys((childError as unknown as Record<string, object>)[control]).length) {
              pathToControl.push(control);
            }

            mapNestedErrors(form, control, pathToControl, childError as unknown as SntServerError);
          }
        });
      }
    }

    if (typeof childError === 'string') {
      childControl.setErrors({ server: childError });
    }
  }
}
